import poem from './poem'

export default {
  activityPoem: poem,
}
